import React from 'react';

import InlineSelectField from '../components/InlineSelectField';
import InlineTextField from '../components/InlineTextField';
import StoreForDeliverySelector from './StoreForDeliverySelector';
import InlineRetailerSelector from './InlineRetailerSelector';
import InlineReplenishmentStrategySelector from './InlineReplenishmentStrategySelector';

const StoreEntry = (props) => {

    const storeForDeliveryOptions = props.deliveryStores.map((deliveryStore) => {
        return {
            id: deliveryStore.gln,
            label: `${deliveryStore.retailer.name}, ${deliveryStore.city} (${deliveryStore.gln})`
        }
    });

    const handleStrategyChange = (option) => {
        props.changeReplenishmentStrategy(props.store.gln, option);
    };

    const handleStoreGlnChange = (newGln) => {
        props.updateStoreGln(props.store.gln, newGln);
    };

    const buildAddress = (newValues) => {
        let address = {
            street: props.store.street,
            zipCode: props.store.zipCode,
            city: props.store.city
        };

        return Object.assign(address, newValues);
    };

    const handleStoreStreetChange = (newStreet) => {
        props.updateStoreAddress(props.store.gln, buildAddress({street: newStreet}));
    };

    const handleStoreZipCodeChange = (newZipCode) => {
        props.updateStoreAddress(props.store.gln, buildAddress({zipCode: newZipCode}));
    };

    const handleStoreCityChange = (newCity) => {
        props.updateStoreAddress(props.store.gln, buildAddress({city: newCity}));
    };

    const handleStoreForDeliveryChange = (storeForDeliveryGln) => {
        props.setStoreForDelivery(props.store.gln, storeForDeliveryGln);
    };

    const assignStoreToRetailer = (retailerGln) => {
        props.assignStoreToRetailer(props.store.gln, retailerGln);
    };

    return (
        <tr>
            <td>
                <InlineRetailerSelector store={props.store} retailers={props.retailers} onCommit={assignStoreToRetailer} />
            </td>
            <td><InlineTextField width='100%' value={props.store.gln} onCommit={handleStoreGlnChange}/></td>
            <td><InlineTextField value={props.store.street} onCommit={handleStoreStreetChange}/></td>
            <td><InlineTextField width='100%' value={props.store.zipCode} onCommit={handleStoreZipCodeChange}/></td>
            <td><InlineTextField value={props.store.city} onCommit={handleStoreCityChange}/></td>
            <td>{props.store.confederation}</td>
            <td>
                <StoreForDeliverySelector
                    store={props.store}
                    options={storeForDeliveryOptions}
                    onCommit={handleStoreForDeliveryChange}/>
            </td>
            <td>
                <InlineReplenishmentStrategySelector store={props.store} onCommit={handleStrategyChange}/>
            </td>
        </tr>
    );
};

export default StoreEntry;



// WEBPACK FOOTER //
// ./src/admin/retailer/StoreEntry.js